import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { ShopProvider } from "@/context/ShopContext";
import { Toaster } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Layout } from "@/components/landing/Layout";
import { ShopLayout } from "@/components/shop/ShopLayout";
import Home from "@/pages/Home";
import PageWhy from "@/pages/PageWhy";
import PageApp from "@/pages/PageApp";
import PageFounder from "@/pages/PageFounder";
import PageWhilsco from "@/pages/PageWhilsco";
import PageContact from "@/pages/PageContact";
import PageDownload from "@/pages/PageDownload";
import PageFAQ from "@/pages/PageFAQ";
import MentionsLegales from "@/pages/MentionsLegales";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SeoPage from "@/pages/SeoPage";
import Catalogue from "@/pages/shop/Catalogue";
import ProduitDetail from "@/pages/shop/ProduitDetail";
import Panier from "@/pages/shop/Panier";
import Checkout from "@/pages/shop/Checkout";
import MesCommandes from "@/pages/shop/MesCommandes";
import Suivi from "@/pages/shop/Suivi";
import Connexion from "@/pages/shop/Connexion";
import Inscription from "@/pages/shop/Inscription";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <ContentProvider>
              <ShopProvider>
              <ScrollToTop />
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/pourquoi-zafara" element={<PageWhy />} />
                  <Route path="/application" element={<PageApp />} />
                  <Route path="/fondateur" element={<PageFounder />} />
                  <Route path="/whilsco-digit" element={<PageWhilsco />} />
                  <Route path="/faq" element={<PageFAQ />} />
                  <Route path="/contact" element={<PageContact />} />
                  <Route path="/telecharger" element={<PageDownload />} />
                  <Route path="/livraison-a-domicile-cotonou" element={<SeoPage />} />
                  <Route path="/courses-en-ligne-cotonou" element={<SeoPage />} />
                  <Route path="/epicerie-en-ligne-cotonou" element={<SeoPage />} />
                  <Route path="/acheter-en-ligne-benin" element={<SeoPage />} />
                  <Route path="/devenir-vendeur" element={<SeoPage />} />
                  <Route path="/devenir-livreur" element={<SeoPage />} />
                </Route>
                <Route element={<ShopLayout />}>
                  <Route path="/catalogue" element={<Catalogue />} />
                  <Route path="/produit/:id" element={<ProduitDetail />} />
                  <Route path="/panier" element={<Panier />} />
                  <Route path="/commande" element={<Checkout />} />
                  <Route path="/mes-commandes" element={<MesCommandes />} />
                  <Route path="/suivi" element={<Suivi />} />
                  <Route path="/suivi/:orderId" element={<Suivi />} />
                  <Route path="/compte/connexion" element={<Connexion />} />
                  <Route path="/compte/inscription" element={<Inscription />} />
                </Route>
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
              <Toaster
                position="bottom-right"
                richColors
                toastOptions={{ style: { fontFamily: "Plus Jakarta Sans, sans-serif" } }}
              />
              </ShopProvider>
            </ContentProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
